import React from "react";
import "./contactUs.css";

const HeroSection = () => {
  return (
    <div className="hero-section-wrapper">
      <h1>
        Got a Vision? <br /> Let’s Build It Together!
      </h1>
      <p className="">
        We’re excited to hear your ideas. Share your project or partnership
        details,
        <br /> and we’ll get back to you within one business day.
      </p>
    </div>
  );
};

export default HeroSection;
